import { render } from "./editShopListModal.vue?vue&type=template&id=7b6efb9c"
import script from "./editShopListModal.vue?vue&type=script&lang=js"
export * from "./editShopListModal.vue?vue&type=script&lang=js"
script.render = render

export default script